export const gridConfig = {
  // regular grid
  1: {
    numCols: 1,
    large: [],
    positionStyles: {
      1: "",
    },
  },
  4: {
    numCols: 4,
    large: [1, 2, 3, 4],
    gridStyle: "sm:[grid-template-columns:1fr_1fr_1fr_1fr] sm:[grid-template-rows:1fr_1fr_1fr_1fr]",
    positionStyles: {
      1: "sm:col-start-1 sm:row-start-1",
      2: "sm:col-start-3 sm:row-start-1",
      3: "sm:col-start-1 sm:row-start-3",
      4: "sm:col-start-3 sm:row-start-3",
    },
  },
  9: {
    numCols: 3,
    large: [],
    gridStyle: "sm:[grid-template-columns:1fr_1fr_1fr_0fr] sm:[grid-template-rows:1fr_1fr_1fr_0fr]",
    positionStyles: {
      1: "sm:col-start-1 sm:row-start-1",
      2: "sm:col-start-2 sm:row-start-1",
      3: "sm:col-start-3 sm:row-start-1",
      4: "sm:col-start-1 sm:row-start-2",
      5: "sm:col-start-2 sm:row-start-2",
      6: "sm:col-start-3 sm:row-start-2",
      7: "sm:col-start-1 sm:row-start-3",
      8: "sm:col-start-2 sm:row-start-3",
      9: "sm:col-start-3 sm:row-start-3",
    },
  },
  // large grid
  3: {
    numCols: 3,
    large: [1],
    gridStyle: "sm:[grid-template-columns:1fr_1fr_1fr_0fr] sm:[grid-template-rows:1fr_1fr_1fr_0fr]",
    positionStyles: {
      1: "sm:col-start-1 sm:row-start-1",
      2: "sm:col-start-3 sm:row-start-1",
      3: "sm:col-start-3 sm:row-start-2",
    },
  },
  6: {
    numCols: 3,
    large: [1],
    gridStyle: "sm:[grid-template-columns:1fr_1fr_1fr_0fr] sm:[grid-template-rows:1fr_1fr_1fr_0fr]",
    positionStyles: {
      1: "sm:col-start-1 sm:row-start-1",
      2: "sm:col-start-3 sm:row-start-1",
      3: "sm:col-start-3 sm:row-start-2",
      4: "sm:col-start-1 sm:row-start-3",
      5: "sm:col-start-2 sm:row-start-3",
      6: "sm:col-start-3 sm:row-start-3",
    },
  },
  7: {
    numCols: 4,
    large: [1, 2, 3],
    gridStyle: "sm:[grid-template-columns:1fr_1fr_1fr_1fr] sm:[grid-template-rows:1fr_1fr_1fr_1fr]",
    positionStyles: {
      1: "sm:col-start-1 sm:row-start-1",
      2: "sm:col-start-3 sm:row-start-1",
      3: "sm:col-start-1 sm:row-start-3",
      4: "sm:col-start-3 sm:row-start-3",
      5: "sm:col-start-4 sm:row-start-3",
      6: "sm:col-start-3 sm:row-start-4",
      7: "sm:col-start-4 sm:row-start-4",
    },
  },
}
